/**
 * @desc 装箱
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.wms.InDeliveryDetailBoxRequestDto>, options?: any) {
  return updateResponse(
    http(URL + `/inMaster/fillBox`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
